import { apiSlice } from '../../api/apiSlice';
import { RoleListParams, RoleListResponse } from './roleListApiSliceTypes';

const roleListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoleList: builder.query<RoleListResponse, RoleListParams>({
            query: (params) => {
                const { page = 1, limit = 10, ...queryParams } = params ?? {};

                return {
                    url: '/roles',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                    params: {
                        page,
                        limit,
                        ...queryParams,
                    },
                };
            },
            providesTags: (result) =>
                result?.data?.items
                    ? [
                          ...result.data.items.map((role) => ({
                              type: 'roles' as const,
                              id: role.id,
                          })),
                          { type: 'roles', id: 'LIST' },
                      ]
                    : [{ type: 'roles', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetRoleListQuery, useLazyGetRoleListQuery } =
    roleListApiSlice;
